export default __webpack_public_path__ + "static/media/box.e39651cf.mov";